import React from "react";
import { PageHeader, BultenItem } from "../Components";
import get_bultens from "actions/get_bultens";
import get_category from "actions/get_category";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { baseUrl } from "env";
class Comp extends React.PureComponent {
  async componentDidMount() {
    await this.props.get_bultens();
  }
  render = () => (
    <div>
      <PageHeader headerClass="contact-us" pageName="Bültenler" />
      <div className="container mt80 mb80">
        <div className="row">
          {this.props.bultens
            ? this.props.bultens.map((item, key) => (
                <BultenItem
                  id={item.id}
                  thumbnail={`${baseUrl}/api/media/media/${item.media_id}`}
                  key={key}
                  col={this.props.screen.mq === "l" ? 4 : 12}
                  title={item.title}
                />
              ))
            : ""}
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  bultens: state.bultens ? state.bultens.data : [],
  screen: state.screen
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      get_bultens,
      get_category
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Comp);
